// extracted by mini-css-extract-plugin
export default {"table":"expense-list_table__yGExW","iconCustom":"expense-list_iconCustom__OmaSH"};